import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

function AnunturileMele() {
  const [anunturi, setAnunturi] = useState([]);
  const [incarca, setIncarca] = useState(true);
  const [filtru, setFiltru] = useState('toate');
  const navigate = useNavigate();

  const taburi = [
    { nume: 'Gestioneaza anunturile', link: '/anunturile-mele', activ: true },
    { nume: 'Comenzile mele', link: '/comenzi', activ: false },
    { nume: 'Mesaje', link: '/mesaje', activ: false },
    { nume: 'Favorite', link: '/favorite', activ: false },
    { nume: 'Alertele mele', link: '/alerte', activ: false },
    { nume: 'Detaliile mele', link: '/setari', activ: false }
  ];

  useEffect(function() {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
      return;
    }
    incarcaAnunturileMele(token);
  }, [navigate]);

  async function incarcaAnunturileMele(token) {
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/anunturi/mele', {
        headers: { 'x-auth-token': token }
      });
      const date = await raspuns.json();
      if (raspuns.ok) {
        setAnunturi(date);
      } else {
        toast.error(date.mesaj);
      }
    } catch (err) {
      toast.error('Eroare la conectarea cu serverul');
    } finally {
      setIncarca(false);
    }
  }

  async function stergeAnunt(id) {
    const confirmat = window.confirm('Sigur vrei sa stergi acest anunt?');
    if (!confirmat) {
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const raspuns = await fetch('https://tranzitio.onrender.com/api/anunturi/' + id, {
        method: 'DELETE',
        headers: { 'x-auth-token': token }
      });
      if (raspuns.ok) {
        toast.success('Anunt sters cu succes');
        const anunturiNoi = [];
        for (let i = 0; i < anunturi.length; i++) {
          if (anunturi[i]._id !== id) {
            anunturiNoi.push(anunturi[i]);
          }
        }
        setAnunturi(anunturiNoi);
      } else {
        const dateEroare = await raspuns.json();
        toast.error(dateEroare.mesaj || 'Nu s-a putut sterge anuntul');
      }
    } catch (err) {
      toast.error('Eroare la stergere');
    }
  }

  function getBadgeStatus(status) {
    if (status === 'aprobat') {
      return { cls: 'bg-emerald-500 text-white', label: 'Publicat' };
    }
    if (status === 'respins') {
      return { cls: 'bg-red-500 text-white', label: 'Respins' };
    }
    return { cls: 'bg-amber-400 text-white', label: 'In asteptare' };
  }

  function getLabelFiltru() {
    if (filtru === 'aprobat') {
      return 'publicate';
    }
    if (filtru === 'in_asteptare') {
      return 'in asteptare';
    }
    if (filtru === 'respins') {
      return 'respinse';
    }
    return 'in total';
  }

  const anunturiFiltrate = [];
  for (let i = 0; i < anunturi.length; i++) {
    if (filtru === 'toate') {
      anunturiFiltrate.push(anunturi[i]);
    } else if (anunturi[i].statusModerare === filtru) {
      anunturiFiltrate.push(anunturi[i]);
    }
  }

  if (incarca) {
    return (
      <div className="min-h-screen bg-[#f3f4f6] flex justify-center items-center">
        <div className="w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f3f4f6]">

      <div className="bg-white border-b border-gray-200 overflow-x-auto">
        <div className="max-w-7xl mx-auto px-4 flex min-w-max">
          {taburi.map(function(tab, index) {
            let clasa = 'flex items-center gap-2 px-6 py-4 text-sm font-bold transition-all border-b-4 ';
            if (tab.activ) {
              clasa = clasa + 'border-blue-600 text-blue-700';
            } else {
              clasa = clasa + 'border-transparent text-gray-500 hover:text-gray-800 hover:bg-gray-50';
            }
            return (
              <Link key={index} to={tab.link} className={clasa}>
                {tab.nume}
              </Link>
            );
          })}
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-8">

        <div className="flex flex-col md:flex-row justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4 md:mb-0">
            {anunturiFiltrate.length} anunturi {getLabelFiltru()}
          </h2>
          <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-gray-200 shadow-sm">
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
            </svg>
            <select
              value={filtru}
              onChange={function(e) { setFiltru(e.target.value); }}
              className="bg-transparent font-bold text-gray-700 focus:outline-none cursor-pointer"
            >
              <option value="toate">Toate anunturile</option>
              <option value="aprobat">Publicate</option>
              <option value="in_asteptare">In asteptare</option>
              <option value="respins">Respinse</option>
            </select>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-12 flex flex-col md:flex-row justify-between items-center gap-4">
          <div>
            <h3 className="font-bold text-gray-800 text-lg">Ai nevoie de ajutor cu platforma?</h3>
            <p className="text-gray-500 font-medium">Citeste ghidul nostru pentru a vinde mai repede si in siguranta.</p>
          </div>
          <Link
            to="/cum-functioneaza"
            className="bg-blue-50 text-blue-700 font-bold px-6 py-2.5 rounded-lg hover:bg-blue-100 transition whitespace-nowrap"
          >
            Citeste ghidul
          </Link>
        </div>

        {anunturiFiltrate.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 bg-white rounded-xl border border-gray-100 shadow-sm">
            <div className="w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center mb-6">
              <svg className="w-12 h-12 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 002-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
            </div>
            <h3 className="text-2xl font-black text-gray-800 mb-2">
              {filtru === 'toate' ? 'Nu ai niciun anunt' : 'Nu ai anunturi ' + getLabelFiltru()}
            </h3>
            <p className="text-gray-500 font-medium mb-8 text-center max-w-sm">
              {filtru === 'toate'
                ? 'Fa curatenie prin lucrurile tale si transforma obiectele nefolosite in bani.'
                : 'Incearca un alt filtru sau adauga un anunt nou.'}
            </p>
            {filtru === 'toate' && (
              <Link
                to="/adauga-anunt"
                className="bg-blue-600 text-white font-bold px-8 py-3.5 rounded-xl hover:bg-blue-700 shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all"
              >
                Vinde acum
              </Link>
            )}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {anunturiFiltrate.map(function(anunt) {
              const badge = getBadgeStatus(anunt.statusModerare);
              return (
                <div key={anunt._id} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden flex flex-col group hover:shadow-md transition">
                  <Link to={'/anunt/' + anunt._id} className="block h-48 bg-gray-100 relative cursor-pointer">
                    {anunt.imagine ? (
                      <img src={anunt.imagine} alt={anunt.titlu} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-gray-400">Fara imagine</div>
                    )}
                    <div className={'absolute top-3 left-3 text-xs font-bold px-2.5 py-1 rounded-lg ' + badge.cls}>
                      {badge.label}
                    </div>
                  </Link>
                  <div className="p-4 flex-grow flex flex-col">
                    {anunt.statusModerare === 'respins' && (
                      <div className="bg-red-50 border border-red-100 rounded-lg px-3 py-2 mb-3 text-xs text-red-600 font-medium">
                        Anuntul tau a fost respins de administrator. Editeaza-l si retrimite-l.
                      </div>
                    )}
                    {anunt.statusModerare === 'in_asteptare' && (
                      <div className="bg-amber-50 border border-amber-100 rounded-lg px-3 py-2 mb-3 text-xs text-amber-700 font-medium">
                        Anuntul asteapta aprobarea unui administrator.
                      </div>
                    )}
                    <Link to={'/anunt/' + anunt._id}>
                      <h3 className="font-bold text-lg mb-1 line-clamp-2 text-gray-800 group-hover:text-blue-600 transition cursor-pointer">
                        {anunt.titlu}
                      </h3>
                    </Link>
                    <p className="text-gray-500 text-sm mb-4">{anunt.locatie || anunt.localitate}</p>
                    <p className="text-blue-700 font-black text-xl mb-6">{anunt.pret} RON</p>
                    <div className="mt-auto grid grid-cols-2 gap-2">
                      <Link
                        to={'/editeaza-anunt/' + anunt._id}
                        className="bg-gray-50 text-gray-700 py-2.5 rounded-lg font-bold hover:bg-gray-100 border border-gray-200 transition text-sm text-center flex items-center justify-center"
                      >
                        Editeaza
                      </Link>
                      <button
                        onClick={function() { stergeAnunt(anunt._id); }}
                        className="bg-white text-rose-500 py-2.5 rounded-lg font-bold hover:bg-rose-50 border border-rose-200 transition text-sm"
                      >
                        Sterge
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

      </div>
    </div>
  );
}

export default AnunturileMele;